var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.63489 6.1333H22.9441V26.3636H8.63489V6.1333ZM10.1152 7.61356V24.8833H21.4638V7.61356H10.1152Z","fill":"#2E2B26","key":0}),React.createElement("path",{"d":"M17.2698 21.1826C17.2698 22.0002 16.607 22.6629 15.7895 22.6629C14.972 22.6629 14.3092 22.0002 14.3092 21.1826C14.3092 20.3651 14.972 19.7024 15.7895 19.7024C16.607 19.7024 17.2698 20.3651 17.2698 21.1826Z","fill":"#2E2B26","key":1})]);
}

Phone.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
